module.exports = __webpack_public_path__ + "shattered.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/css/patterns/shattered.png
// module id = ../../../../../ng-src/assets/css/patterns/shattered.png
// module chunks = styles